import { View } from './view'

export const TabsContent = View
